import { render, staticRenderFns } from "./WorkGroupCreate.vue?vue&type=template&id=fdebb116&"
import script from "./WorkGroupCreate.vue?vue&type=script&lang=js&"
export * from "./WorkGroupCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports